import { initHttpClient } from './core/http-client';
import AuthGuard from './core/auth/auth-guard';

const httpClient = initHttpClient(AuthGuard.httpClient);

/**
 * Récupère la liste des services de cartographie
 * @returns 
 */
export function getMapServices() {
    return httpClient.get('/maps/')
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère la liste des services d'overlay (non géré par nous)
 * @returns 
 */
export function getOverlayServices() {
    return httpClient.get('/external-ovelays/')
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getInternalOverlayTypes() {
    return httpClient.get('/internal-overlays/types')
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère la liste des overlays (géré pas nous) en fonction de la vue de la carte
 * @param {*} bounds Bounding box de la carte
 * @returns 
 */
export function getInternalOverlay(bounds, type) {
    const box = {
        xmin: bounds._southWest.lng,
        ymin: bounds._southWest.lat,
        xmax: bounds._northEast.lng,
        ymax: bounds._northEast.lat,
        type
    };

    return httpClient.get('/internal-overlays/', { params: box })
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getInternalOverlays(bounds, types) {
    const box = {
        xmin: bounds._southWest.lng,
        ymin: bounds._southWest.lat,
        xmax: bounds._northEast.lng,
        ymax: bounds._northEast.lat,
        types: types.join(',')
    };

    return httpClient.get('/internal-overlays/', { params: box })
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère la liste des overlays référentiel en fonction de la vue de la carte
 * @param {*} bounds Bounding box de la carte
 * @param typeRef Nom de la donnée de référence par exemple enedis, Orange, SFR, Free, Bouygues
 * @returns
 */
export function getReferenceOverlay(bounds, typeRef) {
    const box = {
        xmin: bounds._southWest.lng,
        ymin: bounds._southWest.lat,
        xmax: bounds._northEast.lng,
        ymax: bounds._northEast.lat,
        type_ref: typeRef
    };

    return httpClient.get('/references/', { params: box })
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère les infos administratives d'une coordonnée (le double click sur la carte)
 * @param {*} coor 
 * @returns 
 */
export function getPointData(coor) {
    return httpClient.post('/city-info/', {data: coor})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getInternalOverlayById(id) {
    return httpClient.get(`/internal-overlays/${id}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function saveInternalOverlay(overlay) {
    if (overlay.id) {
        return httpClient.put(`/internal-overlays/${overlay.id}`, {data: overlay})
            .catch(httpClient.handleRejection.bind(httpClient));
    }

    return httpClient.post(`/internal-overlays/`, {data: overlay})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function deleteInternalOverlay(id) {
    return httpClient.delete(`/internal-overlays/${id}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function uploadAttachment(formData) {
    return httpClient.post('/attachement-overlays/', {data: formData})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function deleteAttachment(id) {
    return httpClient.delete(`/attachement-overlays/${id}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère les événement d'un jour
 * @param {*} day 
 * @returns 
 */
export function getEvents(day) {
    return httpClient.get('/events/', { params: {day} })
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère le détail d'un événement
 * @param {*} id
 * @returns 
 */
export function getEvent(id) {
    return httpClient.get(`/events/${id}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Sauvegarde (créer/modifier) un événement
 * @param {*} event 
 * @returns 
 */
export function saveEvent(event) {
    return httpClient.post(`/events/`, {data: event})
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Supprime un événement
 * @param {*} id 
 * @returns 
 */
export function deleteEvent(id) {
    return httpClient.delete(`/events/${id}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Récupère la liste des type d'overlay d'événement
 * @returns 
 */
export function getEventOverlayType() {
    return httpClient.get(`/events/overlay/types/`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Joint un fichier à un événement
 * @param {*} eventId Id django de l'événement
 * @param {*} file Le fichier à joindre 
 * @param {*} type Le type de fichier
 * @param {*} displayName Le nom du fichier
 * @returns 
 */
export function deleteEventAttachment(eventId, attachmentId) {
    return httpClient.delete(`/events/${eventId}/attachement/${attachmentId}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function attachFiletoEvent(eventId, file, type, displayName) {
    const data = new FormData();
    
    data.append('file', file);
    data.append('type', type);

    return httpClient.post(`/events/${eventId}/attachement`, { params: {display_name: displayName}, data, headers: {}})
        .catch(httpClient.handleRejection.bind(httpClient));
}

/**
 * Supprime un overlay d'événement
 * @param {*} id 
 * @returns 
 */
export function deleteEventOverlay(id) {
    return httpClient.delete(`/events/overlay/${id}`)
        .then(() => M.toast({html: 'Elément supprimé', classes: 'green accent-4'}))
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getGroupServiceByName(name) {
    return httpClient.get(`/group-services/${name}`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function callService(name, params) {
    return httpClient.get(`/services/${name}`, {params})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function callServicePost(name, params, data) {
    return httpClient.post(`/services/${name}`, {params, data})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getActivities() {
    return httpClient.get(`/events/activities`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getPahtologies() {
    return httpClient.get(`/events/pathologies`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getAccidentTypes() {
    return httpClient.get(`/events/accident-types`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getUserDetails() {
    return httpClient.get(`/users/me`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getSquadDetail() {
    return httpClient.get(`/squads/user`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getHelicopterPartners() {
    return httpClient.get(`/squads/user`)
        .then(squad => squad.helicopter_patners)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function updateHelicopter(helico) {
    return httpClient.put(`/helicopters/`, {data: helico})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getSms(idEvent) {
    return httpClient.get(`/sms/`, {params: idEvent ? {event: idEvent} : undefined})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getMessageTypes() {
    return httpClient.get(`/sms/types`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getMessageLangs() {
    return httpClient.get(`/sms/langs`)
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function sendMessage(message) {
    return httpClient.post(`/sms/send`, {data: message})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function sendTchapMessage(data) {
    return httpClient.post(`/tchap/send`, {data})
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getGeoIP() {
    return httpClient.get('https://ipapi.co/json')
        .then((data) => data.country || 'FR')
        .catch(httpClient.handleRejection.bind(httpClient));
}

export function getEventDrawableAttachments(eventId, attachmentId = null, { onError } = {}) {
    const params = attachmentId ? { 'attachment_id': attachmentId } : undefined;

    return httpClient.get(`/events/${eventId}/attachements/drawable`, {params})
        .catch(onError ?? httpClient.handleRejection.bind(httpClient));
}

export function closeEvent(eventId) {
    return httpClient.put(`/events/${eventId}/close`, {getRawResponse: true})
        .then(async (response) => response.blob())
        .catch(httpClient.handleRejection.bind(httpClient));
}
